import { defineComponent as _defineComponent } from 'vue'
import { ContentLoader, BaseComponent } from '@tencent/wphk-components-content-loader';

export default /*#__PURE__*/_defineComponent({
  __name: 'travel-tool-skeleton',
  props: {
    isReady: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true,ContentLoader, BaseComponent }
}

})